export const getLingualErrors = (errors: Record<string, string[]>, name: string) => {
    const collection: string[] = [];

    Object.entries(errors).forEach(([key, value]) => {
        if (key.split('_')[0] === name) collection.push(...value);
    });

    return collection;
};
